interface SpinnerProps {
  size?: number;
  className?: string;
  label?: string;
}

// PR-UX-04 loading state · paired with role="status" for SR.
// PR-UX-10 motion · honors prefers-reduced-motion via global CSS.
export default function Spinner({ size = 16, className = '', label }: SpinnerProps) {
  return (
    <span
      role="status"
      aria-live="polite"
      className={`inline-block border-2 border-current border-t-transparent rounded-full animate-spin ${className}`}
      style={{ width: size, height: size }}
    >
      {label && <span className="sr-only">{label}</span>}
    </span>
  );
}
